module.exports = __webpack_public_path__ + "img/Ben Hill Station Concepts_Page_2.ee245ecc.jpg";